import { Injectable } from '@angular/core';
import { LocationsEntity, LoyaltyMode} from '@core/redux/stores';
import * as moment from 'moment-timezone';
@Injectable()
export class VisitService {

  private cstTimeZone = 'America/Chicago';

  setLocationEntity(locationEntity: LocationsEntity) {
    if (locationEntity) {
      sessionStorage.setItem('visitlocationselected', JSON.stringify(locationEntity));
    }
  }

  getLocationEntity(): LocationsEntity {
    const location = sessionStorage.getItem('visitlocationselected');
    if (location) {
      return JSON.parse(location);
    }
    return null;
  }

  removeLocationEntity() {
    sessionStorage.removeItem('visitlocationselected');
  }

  setCurrentTime() {
    sessionStorage.setItem('lastVisitAdded', moment.tz(this.cstTimeZone).toISOString());
  }
  canAddVisit(): boolean {
    if (sessionStorage.getItem('lastVisitAdded')) {
      const lastVisit = sessionStorage.getItem('lastVisitAdded');
      if (moment(lastVisit).isValid) {
        return !moment(lastVisit).isSame(moment.tz(this.cstTimeZone), 'day');
      }
    }
    return true;
  }
  getComponentTitle(loyaltyMode: LoyaltyMode) {
    return loyaltyMode == LoyaltyMode.Points ? 'Add Points From Receipt' : 'Add a Visit';
  }
}
